/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_Update_FailedInputs */

const en_cargos_update_failed = /** @type {(inputs: Cargos_Update_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to update cargos`)
};

const es_cargos_update_failed = /** @type {(inputs: Cargos_Update_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron actualizar las cargas`)
};

/**
* | output |
* | --- |
* | "Failed to update cargos" |
*
* @param {Cargos_Update_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_update_failed = /** @type {((inputs?: Cargos_Update_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_Update_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_update_failed(inputs)
	return es_cargos_update_failed(inputs)
});